// C:\Users\avnis\CareCo-OrdinatorDashboard\client\src\CareCoordinator\data\admindata.js

const BASE = process.env.REACT_APP_API_BASE_URL;

function authHeaders(json = true) {
  const token = localStorage.getItem("token");
  const h = { Authorization: `Bearer ${token}` };
  if (json) h["Content-Type"] = "application/json";
  return h;
}

export function extractArray(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw.data)) return raw.data;
  return [];
}

export function extractObject(raw) {
  if (!raw) return null;
  if (raw.data && typeof raw.data === "object" && !Array.isArray(raw.data))
    return raw.data;
  if (typeof raw === "object" && !Array.isArray(raw) && raw.patient_id)
    return raw;
  return null;
}

/**
 * [ADMIN] Fetch all care coordinators.
 * GET /api/program/listpatients?view=task_list
 * (no patient_id, no care_coordinator_id)
 *
 * Response shape:
 * { data: [ { care_coordinator_id, name, email, phone_no, patient_count } ] }
 */
export async function listAllCareCoordinators() {
  const params = new URLSearchParams({ view: "task_list" });
  const res = await fetch(`${BASE}/api/program/listpatients?${params}`, {
    method: "GET",
    headers: authHeaders(false),
  });
  if (!res.ok) throw new Error(`List care coordinators failed: ${res.status}`);
  return res.json();
}

/**
 * [ADMIN] Fetch all patients under a specific care coordinator.
 * GET /api/program/listpatients?view=task_list&care_coordinator_id=<id>
 *
 * Response shape:
 * { data: [ { patient_id, user_profile, tasklist_id, program_id, ... } ] }
 */
export async function listPatientsByCareCoordinator(careCoordinatorId) {
  const params = new URLSearchParams({
    view: "task_list",
    care_coordinator_id: careCoordinatorId,
  });
  const res = await fetch(`${BASE}/api/program/listpatients?${params}`, {
    method: "GET",
    headers: authHeaders(false),
  });
  if (!res.ok)
    throw new Error(`List patients by coordinator failed: ${res.status}`);
  return res.json();
}

/**
 * [ADMIN] Fetch full patient detail under a specific care coordinator.
 * GET /api/program/listpatients?view=task_list&patient_id=<pid>&care_coordinator_id=<cid>
 *
 * Response shape: full care journey + patient profile
 */
export async function fetchAdminPatientDetail(patientId, careCoordinatorId) {
  const params = new URLSearchParams({
    view: "task_list",
    patient_id: patientId,
    care_coordinator_id: careCoordinatorId,
  });
  const res = await fetch(`${BASE}/api/program/listpatients?${params}`, {
    method: "GET",
    headers: authHeaders(false),
  });
  if (!res.ok) throw new Error(`Fetch admin patient detail failed: ${res.status}`);
  return res.json();
}

/**
 * [ADMIN] Fetch NCD data for all patients under a specific care coordinator.
 * GET /api/program/listpatients?view=ncd_data&care_coordinator_id=<id>
 */
export async function listNcdPatientsByCareCoordinator(careCoordinatorId) {
  const params = new URLSearchParams({
    view: "ncd_data",
    care_coordinator_id: careCoordinatorId,
  });
  const res = await fetch(`${BASE}/api/program/listpatients?${params}`, {
    method: "GET",
    headers: authHeaders(false),
  });
  if (!res.ok)
    throw new Error(`List NCD patients by coordinator failed: ${res.status}`);
  return res.json();
}